import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import {
  UserBlockLeaveForm,
  UserBlockLeaveFormFieldTypes,
} from '../../user-block-leave-form/user-block-leave-form.tsx'
import { FormInstance } from 'antd/lib'
import './user-block-leave-modal.scss'
import { useTranslation } from 'react-i18next'

interface UserBlockLeaveModalProps {
  userId: string | null
  showBlockLeaveModal: boolean
  form: FormInstance<UserBlockLeaveFormFieldTypes>
  handleCloseModal: () => void
}

export const UserBlockLeaveModal: React.FC<UserBlockLeaveModalProps> = ({
  userId,
  showBlockLeaveModal,
  form,
  handleCloseModal,
}) => {
  const { t } = useTranslation()
  return (
    <IdeyaModal
      open={showBlockLeaveModal}
      title={t('user_management.user_modal.block_leave_modal.apply_leave_dates')}
      destroyOnClose
      isForm={true}
      width={700}
      className={'user-block-leave-modal'}
      onCancel={handleCloseModal}
    >
      <UserBlockLeaveForm
        handleCloseModal={handleCloseModal}
        userId={userId}
        form={form}
      />
    </IdeyaModal>
  )
}
